export default class DownloadSpeed {
  errorOnLoadImage = false;

  async getDownloadSpeed() {
    let bitsLoaded = 0;
    const downloadImageUrl = process.env.REACT_APP_DOWNLOAD_SPEED_IMAGE_URL as string;
    const downloadImageSize = parseInt(process.env.REACT_APP_DOWNLOAD_SPEED_IMAGE_SIZE as string);
    
    const startTime = new Date().getTime();
    const cacheBuster = `?nnn=${startTime}`;
    
    this.errorOnLoadImage = false;
    await this.loadImage(downloadImageUrl + cacheBuster);

    const endTime = new Date().getTime();

    if (!this.errorOnLoadImage) {
      bitsLoaded = downloadImageSize * 8;
    }
    
    const duration = (endTime - startTime) / 1000;

    let speedBps = 0;
    if (duration !== 0) {
      speedBps = bitsLoaded / duration;
    }

    const speedKbps = speedBps / 1024;
    const speedMbps = speedKbps / 1024;

    return speedMbps.toFixed(2);
  }

  loadImage(url: string) {
    return new Promise(resolve => {
      fetch(url)
        .then(response => {
          if (response.ok) {
            return resolve(url);
          }
          this.errorOnLoadImage = true;
          return resolve(url);
        })
        .catch(error => {
          this.errorOnLoadImage = true;
          resolve(url);
        });
    });
  }
}
